import React from "react";
import { useSelector } from "react-redux";
import { canManageNotificationEventRouting } from "../helper/permissions";
import Unauthorize from "./Unauthorize";

function NotificationEventRoutingAdminGuard({ children }) {
  const login = useSelector((state) => state.root.login.loginDemo);

  return canManageNotificationEventRouting(login) ? children : <Unauthorize />;
}

export default NotificationEventRoutingAdminGuard;
